var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 94,
    viewBox: "0 0 287 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 93H9C4.58172 93 1 89.4183 1 85V21.5344V9.53674e-07",
    stroke: "#00FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep22);
export default __webpack_public_path__ + "static/media/step_2 (2).ec01aa1f13a12657e6d71ffe0141b2d6.svg";
export { ForwardRef as ReactComponent };